'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { type ChangeEvent, useEffect, useRef, useState } from 'react';
import { SEARCH_QUERY_PARAM_KEY } from '@module/mdrt-org/shared/utils/constants/learn-search-constants';
import { Input } from '@shared/ui-components/input/input';
import { CloseIcon, MagnifierIcon } from '@shared/ui-components/svgs';
import { type SearchCmsContent } from '../../graphql/get-search-cms-content';
import { type SearchPageSearchParameters } from '../../types';
import { SearchSuggestions } from './components/search-suggestions/search-suggestions';
import styles from './search-bar.module.scss';
type SearchBarProps = {
  onSearchQueryChange: (searchParameters: SearchPageSearchParameters) => void;
  searchPageCmsContent: SearchCmsContent['searchPage'];
};
export const SearchBar = t0 => {
  const $ = _c(36);
  const {
    onSearchQueryChange,
    searchPageCmsContent
  } = t0;
  const searchParameters = useSearchParams();
  const inputRef = useRef(null);
  let t1;
  if ($[0] !== searchParameters) {
    t1 = searchParameters.get(SEARCH_QUERY_PARAM_KEY) ?? "";
    $[0] = searchParameters;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [searchQueryValue, setSearchQueryValue] = useState(t1);
  let t2;
  let t3;
  if ($[2] !== searchParameters) {
    t2 = () => {
      setSearchQueryValue(searchParameters.get(SEARCH_QUERY_PARAM_KEY) ?? "");
    };
    t3 = [searchParameters];
    $[2] = searchParameters;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = event => setSearchQueryValue(event.target.value);
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleInputChange = t4;
  let t5;
  if ($[6] !== onSearchQueryChange || $[7] !== searchParameters) {
    t5 = () => {
      setSearchQueryValue("");
      inputRef.current?.focus();
      if (searchParameters.get(SEARCH_QUERY_PARAM_KEY)) {
        onSearchQueryChange({
          [SEARCH_QUERY_PARAM_KEY]: ""
        });
      }
    };
    $[6] = onSearchQueryChange;
    $[7] = searchParameters;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleSearchQueryClear = t5;
  let t6;
  if ($[9] !== onSearchQueryChange || $[10] !== searchQueryValue) {
    t6 = () => {
      onSearchQueryChange({
        [SEARCH_QUERY_PARAM_KEY]: searchQueryValue ?? ""
      });
      inputRef.current?.blur();
    };
    $[9] = onSearchQueryChange;
    $[10] = searchQueryValue;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const submitSearchQuery = t6;
  let t7;
  if ($[12] !== onSearchQueryChange) {
    t7 = title => {
      setSearchQueryValue(title);
      onSearchQueryChange({
        [SEARCH_QUERY_PARAM_KEY]: title
      });
    };
    $[12] = onSearchQueryChange;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const handleSuggestionClick = t7;
  let t8;
  if ($[14] !== searchParameters) {
    t8 = searchParameters.get(SEARCH_QUERY_PARAM_KEY);
    $[14] = searchParameters;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <MagnifierIcon className={styles["input-icon"]} />;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = searchPageCmsContent?.SearchInputPlaceholder || "Search resources";
  let t11;
  if ($[17] !== searchQueryValue || $[18] !== t10) {
    t11 = <Input autoComplete="off" className={styles.input} data-testid="learn-search-input" leadingIcon={t9} name="learn-search-input" onChange={handleInputChange} placeholder={t10} ref={inputRef} value={searchQueryValue} />;
    $[17] = searchQueryValue;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== handleSearchQueryClear || $[21] !== searchPageCmsContent?.SearchInputClearButtonLabel || $[22] !== searchQueryValue) {
    t12 = searchQueryValue && <button aria-label={searchPageCmsContent?.SearchInputClearButtonLabel || "Clear button"} className={styles["clear-button"]} onClick={handleSearchQueryClear} type="button"><CloseIcon /></button>;
    $[20] = handleSearchQueryClear;
    $[21] = searchPageCmsContent?.SearchInputClearButtonLabel;
    $[22] = searchQueryValue;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12) {
    t13 = <div className={styles["buttons-container"]}>{t12}</div>;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== submitSearchQuery || $[27] !== t11 || $[28] !== t13 || $[29] !== t8) {
    t14 = <form action={submitSearchQuery} className={styles["search-bar"]} key={t8}>{t11}{t13}</form>;
    $[26] = submitSearchQuery;
    $[27] = t11;
    $[28] = t13;
    $[29] = t8;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== handleSuggestionClick) {
    t15 = <SearchSuggestions onSuggestionClick={title_0 => handleSuggestionClick(title_0)} />;
    $[31] = handleSuggestionClick;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t14 || $[34] !== t15) {
    t16 = <div className={styles.wrapper}>{t14}{t15}</div>;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
};